import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.damage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-damage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.damage/view.scss */
/* src/app/page.damage/view.scss: no such file or directory */`],
})
export class PageDamageComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = null;

    // 손상 종류 관리
    public labels: string[] = [];
    public newLabelName: string = '';
    public isSavingLabels: boolean = false;
    public labelSaveMsg: any = null;

    // 동적 색상 팔레트
    private readonly HEX_PALETTE = [
        '#EF4444', '#F59E0B', '#8B5CF6', '#10B981', '#3B82F6',
        '#EC4899', '#F97316', '#14B8A6', '#84CC16', '#6366F1',
        '#F43F5E', '#0EA5E9', '#D946EF', '#22C55E', '#CA8A04'
    ];

    public async ngOnInit() {
        await this.service.init();
        await Promise.all([this.load(), this.loadLabels()]);
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("overview");
        if (code === 200) {
            this.data = data;
        }
        await this.service.render();
    }

    public async loadLabels() {
        const { code, data } = await wiz.call('get_labels');
        if (code === 200) {
            this.labels = data.labels;
        }
    }

    public getHexByIndex(i: number): string {
        return this.HEX_PALETTE[i % this.HEX_PALETTE.length];
    }

    public async addLabel() {
        const name = this.newLabelName.trim();
        if (!name) return;
        if (this.labels.includes(name)) {
            this.labelSaveMsg = { ok: false, text: '이미 존재하는 손상 종류입니다.' };
            await this.service.render();
            return;
        }
        this.labels = [...this.labels, name];
        this.newLabelName = '';
        await this.saveLabels();
    }

    public async removeLabel(i: number) {
        const label = this.labels[i];
        const ok = await this.service.modal.show({
            title: '삭제 확인',
            message: `"${label}" 손상 종류를 삭제하시겠습니까?\n기존 어노테이션 데이터에는 영향을 주지 않습니다.`,
            action: '삭제',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.labels = this.labels.filter((_, idx) => idx !== i);
        await this.saveLabels();
    }

    public async saveLabels() {
        this.isSavingLabels = true;
        this.labelSaveMsg = null;
        await this.service.render();
        const { code } = await wiz.call('save_labels', { labels: JSON.stringify(this.labels) });
        this.isSavingLabels = false;
        if (code === 200) {
            this.labelSaveMsg = { ok: true, text: '저장되었습니다.' };
            setTimeout(async () => { this.labelSaveMsg = null; await this.service.render(); }, 3000);
        } else {
            this.labelSaveMsg = { ok: false, text: '저장에 실패했습니다.' };
        }
        await this.service.render();
    }

    public getStatusBadge(status: string) {
        const map: any = {
            'uploaded': 'bg-blue-100 text-blue-700',
            'annotated': 'bg-green-100 text-green-700',
            'trained': 'bg-purple-100 text-purple-700',
            'training': 'bg-yellow-100 text-yellow-700',
            'completed': 'bg-green-100 text-green-700',
            'failed': 'bg-red-100 text-red-700'
        };
        return map[status] || 'bg-zinc-100 text-zinc-700';
    }

    public navigate(path: string) {
        this.service.href(path);
    }
}

export default PageDamageComponent;